import { IReportItem } from "./reports-Item.model";
import { IReportBase } from "./reports-base.model";
import { IReportItemList } from "./reports.item-list.model";

export class ReportBuilder extends IReportBase {
    pageSize: number;
    pageStartIndex: number;
    totalNumberOfRecords: number;
    requestType: string;
    reportPrivilegedNotes:string;
    reports:IReportItem[];
}